// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ProductAttributesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ProductAttributesQuery = { __typename?: 'Query', attributes: Array<{ __typename?: 'ProductAttribute', id: string, value: string, type: Types.ProductAttributeType }>, productStatuses: Array<{ __typename?: 'ProductStatusDetail', name: string, code: Types.ProductStatus }> };


export const ProductAttributesDocument = gql`
    query ProductAttributes {
  attributes(filter: {type: [BRAND, FINISH, DESIGN_PACKAGE, MARKET]}) {
    id
    value
    type
  }
  productStatuses {
    name
    code
  }
}
    `;

/**
 * __useProductAttributesQuery__
 *
 * To run a query within a React component, call `useProductAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductAttributesQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductAttributesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProductAttributesQuery, ProductAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductAttributesQuery, ProductAttributesQueryVariables>(ProductAttributesDocument, options);
      }
export function useProductAttributesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductAttributesQuery, ProductAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductAttributesQuery, ProductAttributesQueryVariables>(ProductAttributesDocument, options);
        }
// @ts-ignore
export function useProductAttributesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProductAttributesQuery, ProductAttributesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductAttributesQuery, ProductAttributesQueryVariables>;
export function useProductAttributesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductAttributesQuery, ProductAttributesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductAttributesQuery | undefined, ProductAttributesQueryVariables>;
export function useProductAttributesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductAttributesQuery, ProductAttributesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProductAttributesQuery, ProductAttributesQueryVariables>(ProductAttributesDocument, options);
        }
export type ProductAttributesQueryHookResult = ReturnType<typeof useProductAttributesQuery>;
export type ProductAttributesLazyQueryHookResult = ReturnType<typeof useProductAttributesLazyQuery>;
export type ProductAttributesSuspenseQueryHookResult = ReturnType<typeof useProductAttributesSuspenseQuery>;
export type ProductAttributesQueryResult = Apollo.QueryResult<ProductAttributesQuery, ProductAttributesQueryVariables>;